export default __webpack_public_path__ + "static/media/Task Completed.9412e38b.svg";